module.exports = __webpack_public_path__ + "img/20200529_142303.4e753abd.jpg";